(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const arrow = event.target.closest('.bvp-arrow');
    if (!arrow) return;
    const rail = arrow.closest('.bvp-scroll')?.querySelector('.bvp-rail');
    if (!rail) return;
    const step = rail.querySelector('label')?.getBoundingClientRect().width || rail.clientWidth / 2;
    rail.scrollBy({ left: Number(arrow.dataset.bvpDirection) * (step + 10), behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
